<template>
  <div class="grid-container">
    <div
      class="grid-container-12 border-2 my-[50px] sm:py-[100px] px-4 sm:px-[116px]"
    >
      <div
        class="flex flex-col sm:flex-row-reverse items-stretch justify-between my-12 md:my-0"
      >
        <div class="content-center">
          <span class="font-bold">{{ contact?.name }} </span><br />
          <template v-if="contact?.jobTitle">
            <span>{{ contact?.jobTitle }}</span>
            <br />
          </template>
          {{ contact?.fieldBusinessArea?.name }} <br />
          <div v-if="contact?.phoneNumber">
            <a
              class="button is-text-only p-0"
              :href="'tel:' + contact?.phoneNumber"
            >
              {{ contact?.phoneNumber }}
            </a>
          </div>
        </div>
        <div class="content-center me-0 xs:me-12">
          <h3 class="text-3xl lg:text-4xl mt-6 md:mt-0">
            <span class="lg:whitespace-nowrap">
              {{
                $texts('contact_pressrelease_title', 'Für weitere Auskünfte')
              }}
            </span>
          </h3>
          <div class="mt-10 inline-block">
            <a class="button" :href="`mailto:${contact?.mail}`">
              {{ $texts('contact_button', 'Kontakt') }}
              <SpriteSymbol name="paperplane" class="size-6 md:size-5" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { NodePressReleaseFragment } from '#graphql-operations'

defineProps<{
  contact: NodePressReleaseFragment['contact']
}>()
const { $texts } = useEasyTexts()
</script>
